import * as React from 'react';

import SubscribedNotificationSource from '../Source/SubscribedNotificationSource/SubscribedNotificationSource';
import { Provider } from './SubscribedNotificationsContext';

class SubscribedNotificationsProvider extends React.PureComponent<React.PropsWithChildren<unknown>> {
  render() {
    return (
      <SubscribedNotificationSource>
        {(subscribedNotifications, helpers) => (
          <Provider
            value={{
              subscribedNotifications,
              subscribedNotificationHelpers: helpers,
            }}
          >
            {this.props.children}
          </Provider>
        )}
      </SubscribedNotificationSource>
    );
  }
}

export default SubscribedNotificationsProvider;
